import { useMutation } from '@tanstack/react-query';
import { CompaniesService } from 'api';
import { CommonCompanyProfileSuggest } from 'api/models/CommonCompanyProfileSuggest';

export const useSuggestCommonProfile = () =>
  useMutation({
    mutationFn: (data: CommonCompanyProfileSuggest) =>
      CompaniesService.apiCompaniesCommonProfilesSuggestCreate(data),
  });
